import { isLoggedIn } from 'utils/auth';

export default (store) => {
  return {
    path: "campaign-analytics",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const campaignDetailsV2 = require("./CampaignDetails").default;
          cb(null, campaignDetailsV2);
        },
        "campaignDetails"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/CampaignDetails/index.js